<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  username?: string
  size?: string | number
  color?: string
}

const props = withDefaults(defineProps<Props>(), {
  username: '',
  size: 'medium',
  color: ''
})

// 根据用户名生成头像颜色
const avatarColor = computed(() => {
  if (props.color) return props.color
  
  const colors = ['primary', '#FFD43A', '#ADFF00', '#262824', 'danger']
  const index = (props.username || '').charCodeAt(0) % colors.length
  return colors[index]
})

// 生成头像文字
const fallbackText = computed(() => {
  if (!props.username) return '?'
  
  try {
    const [firstName, lastName] = props.username.split(' ')
    if (lastName) {
      return `${firstName[0]}${lastName[0]}`
    }
    return firstName[0] || '?'
  } catch {
    return props.username[0] || '?'
  }
})
</script>

<template>
  <VaAvatar
    :size="size"
    :fallback-text="fallbackText"
    :color="avatarColor"
  />
</template>
